<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Bill Of Material" active>

                                <b-row v-if="hasFailedDataBillOfMaterial">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedBillOfMaterial.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfMaterialsFailed" :fields="fieldsBillOfMaterial" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfMaterial" :sort-desc.sync="sortDescBillOfMaterial" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedBillOfMaterial.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfMaterials" :fields="fieldsBillOfMaterial" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfMaterial" :sort-desc.sync="sortDescBillOfMaterial" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Bill Of Material Detail" active>

                                <b-row v-if="hasFailedDataBillOfMaterialDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedBillOfMaterialDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfMaterialDetailsFailed" :fields="fieldsBillOfMaterialDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfMaterialDetail" :sort-desc.sync="sortDescBillOfMaterialDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(usedQty)="row">
													{{ Number(row.item.usedQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedBillOfMaterialDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="billOfMaterialDetails" :fields="fieldsBillOfMaterialDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByBillOfMaterialDetail" :sort-desc.sync="sortDescBillOfMaterialDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(usedQty)="row">
													{{ Number(row.item.usedQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import BillOfMaterial from '@/models/BillOfMaterial/BillOfMaterial';
import BillOfMaterialList from '@/models/BillOfMaterial/BillOfMaterialList';
import BillOfMaterialFilter from '@/filters/BillOfMaterial/BillOfMaterialFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsBillOfMaterial: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partNumberPartNumber', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsBillOfMaterialDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partNumberPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Used Qty", key: 'usedQty', sortable: false},
				{"class" : "th-status", "label" : "Part Price", key: 'partPricePart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			billOfMaterials : [],
			billOfMaterialsFailed: [],
			billOfMaterialId : '',
			sortByBillOfMaterial: '',
			sortDescBillOfMaterial: '',
			hasFailedDataBillOfMaterial: false,
			totalFailedBillOfMaterial: 0,
			totalSucceedBillOfMaterial: 0,
			billOfMaterialDetails : [],
			billOfMaterialDetailsFailed: [],
			billOfMaterialDetailId : '',
			sortByBillOfMaterialDetail: '',
			sortDescBillOfMaterialDetail: '',
			hasFailedDataBillOfMaterialDetail: false,
			totalFailedBillOfMaterialDetail: 0,
			totalSucceedBillOfMaterialDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('billofmaterial/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('billofmaterial/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getBillOfMaterialForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getBillOfMaterialForUpload : async function() {
			let _this = this;
			this.$http.get('billofmaterial/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.billOfMaterials = [];
_this.billOfMaterialDetails = [];


					if (response != null) {
						let result = response.data;
						_this.billOfMaterials = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedBillOfMaterial = _this.billOfMaterials.length;

						_this.billOfMaterialsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataBillOfMaterial = true;
						_this.totalFailedBillOfMaterial = 0;
						if(_this.billOfMaterialsFailed == undefined || _this.billOfMaterialsFailed.length === 0) _this.hasFailedDataBillOfMaterial = false;
						if(_this.hasFailedDataBillOfMaterial) _this.totalFailedBillOfMaterial = _this.billOfMaterialsFailed.length;
						_this.billOfMaterialDetails = [];
						_this.billOfMaterialDetailsFailed = [];
						_this.hasFailedDataBillOfMaterialDetail = true;
						_this.totalSucceedBillOfMaterialDetail = 0;
						result.forEach(function(element) {
							_this.billOfMaterialDetails.push(...element.billOfMaterialDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedBillOfMaterialDetail = _this.billOfMaterialDetails.length;

							_this.billOfMaterialDetailsFailed.push(...element.billOfMaterialDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.billOfMaterialDetailsFailed == undefined || _this.billOfMaterialDetailsFailed.length === 0) _this.hasFailedDataBillOfMaterialDetail = false;
							if(_this.hasFailedDataBillOfMaterialDetail) _this.totalFailedBillOfMaterialDetail = _this.billOfMaterialDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'billofmaterial/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'BillOfMaterial.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterBillOfMaterial = new BillOfMaterialFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
